import { Table, TableProps } from "antd";
import { ColumnType, ColumnsType } from "antd/es/table";
import { Key } from "react";

import "./DrawerTable.css";

export interface DrawerTableColumn<T> extends Omit<ColumnType<T>, "dataIndex"> {
    dataIndex: keyof T | string;
}

interface DrawerTableProps<T> {
    dataSource: T[];
    columns: DrawerTableColumn<T>[];
    rowKey?: (record: T) => Key;
    scroll?: TableProps<T>["scroll"];
    tableLayout?: TableProps<T>["tableLayout"];
}

export const DrawerTable = <T extends object>({
    dataSource,
    columns,
    rowKey,
    scroll,
    tableLayout,
}: DrawerTableProps<T>) => {
    const antdColumns: ColumnsType<T> = columns.map((col) => ({
        ...col,
        dataIndex: col.dataIndex as string,
    }));

    return (
        <Table<T>
            dataSource={dataSource}
            columns={antdColumns}
            pagination={false}
            bordered
            size="small"
            className="drawer-table"
            rowKey={rowKey}
            scroll={scroll}
            tableLayout={tableLayout}
        />
    );
};
